import EncryptedStorage from 'core/utils/constants/encryptedStorage';
import React, { useEffect, useState, useCallback } from "react";
import httpclient from "libs/Axios";
import { getCurrentHostContext } from 'core/utils/hostname';

const isUserLoggedIn = () => {
  const dataInfo = EncryptedStorage.getItem('_DATA_');
  return JSON.parse(dataInfo || "{}")?.IS_LOGGED_IN;
};

const ExternalTemplateLoader = () => {
  const [Component, setComponent] = useState(null);
  const [templateName, setTemplateName] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Redirect to login if subdomain or template name is missing
  // const redirectToLogin = useCallback(() => {
  //   console.log("Redirecting to login...");
  //   window.location.href = "/login";
  // }, []);

  const redirectToLogin = useCallback(() => {
    if (!isUserLoggedIn()) {
      console.log("Redirecting to login...");
      window.location.href = "/login";
    } else {
      window.location.href = "/dashboard";
      console.log("User already logged in, skipping login redirect");
    }
  }, []);

  // Extract subdomain and fetch template name
  useEffect(() => {
    const domain = getCurrentHostContext().schoolSubdomain;

    // Check if subdomain exists (not default)
    if (!domain) {
      console.log("No valid subdomain found, redirecting to login");
      redirectToLogin();
      return;
    }

    const fetchTemplateName = async () => {
      try {
        const response = await httpclient().post("/master/Website/getTemplateNameByDomain", {
          DOMAIN_NAME: domain
        });

        const data = response?.data?.data;

        if (data?.TEMPLATE_NAME) {
          setTemplateName(data.TEMPLATE_NAME);
          EncryptedStorage.setItem("LP_BRANCH_ID", data.B);
          EncryptedStorage.setItem("LP_INSTITUTE_ID", data.I);
        } else {
          console.log("No template name found, redirecting to login");
          redirectToLogin();
        }
      } catch (err) {
        console.error('Error fetching template name:', err);
        setError(err.message);
        redirectToLogin();
      }
    };

    fetchTemplateName();
  }, [redirectToLogin]);

  // Load CSS and JS after template name is set
  useEffect(() => {
    if (!templateName) return;

    let libStyle, libScript;

    const loadResources = async () => {
      try {
        setLoading(true);

        // Load CSS first
        libStyle = document.createElement("link");
        libStyle.rel = "stylesheet";
        libStyle.href = `https://storage.soomuch.ai/data-soomuch/MASTER/TEMPLATE/${templateName}/SOURCE_${templateName}/styles.css`;

        await new Promise((resolve, reject) => {
          libStyle.onload = resolve;
          libStyle.onerror = () => reject(new Error("Failed to load CSS"));
          document.head.appendChild(libStyle);
        });

        console.log("CSS loaded successfully ✅");

        // Load JS after CSS
        libScript = document.createElement("script");
        libScript.src = `https://storage.soomuch.ai/data-soomuch/MASTER/TEMPLATE/${templateName}/SOURCE_${templateName}/index.js`;
        libScript.type = "text/javascript";
        libScript.async = true;

        await new Promise((resolve, reject) => {
          libScript.onload = () => {
            console.log("JS loaded successfully ✅");
            // Check if component is available
            if (window[templateName]) {
              setComponent(() => window[templateName].default || window[templateName]);
              resolve();
            } else {
              reject(new Error(`window.${templateName} not found`));
            }
          };
          libScript.onerror = () => reject(new Error("Failed to load external JS"));
          document.body.appendChild(libScript);
        });

        setLoading(false);
      } catch (err) {
        console.error("Error loading resources:", err);
        setError(err.message);
        setLoading(false);
      }
    };

    loadResources();

    return () => {
      if (libStyle && document.head.contains(libStyle)) {
        document.head.removeChild(libStyle);
      }
      if (libScript && document.body.contains(libScript)) {
        document.body.removeChild(libScript);
      }
    };
  }, [templateName]);

  // Handle external sign-in events
  // useEffect(() => {
  //   const handleSignIn = () => {
  //     if (isUserLoggedIn()) {
  //       console.log("Sign in clicked ✅");
  //         window.location.href = "/dashboard";
  //       } else {
  //         redirectToLogin();
  //       }
  //   };

  //   window.addEventListener("external-sign-in", handleSignIn);
  //   return () => {
  //     window.removeEventListener("external-sign-in", handleSignIn);
  //   };
  // }, [redirectToLogin]);

  useEffect(() => {
    const handleSignIn = () => {
      console.log("Sign in clicked ✅");
      redirectToLogin();
    };

    window.addEventListener("external-sign-in", handleSignIn);
    return () => {
      window.removeEventListener("external-sign-in", handleSignIn);
    };
  }, [redirectToLogin]);


  // Render based on state
  if (error) {
    return <div>Error: {error}</div>;
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  return Component ? <Component /> : <div>Component not available</div>;
};

export default ExternalTemplateLoader;
